var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.step.is_blueprint)?_c('div',{staticClass:"d-flex"},[_c('v-spacer'),_c('v-btn',{staticClass:"mr-3",attrs:{"color":"secondary"},on:{"click":function (e) {
        e.stopPropagation();
        _vm.$emit('addRequirementsToStep', _vm.step, 'requires');
      }}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-clock-in")]),_vm._v(" \"Benötigt\" übernehmen ")],1),_c('v-btn',{staticClass:"mr-3",attrs:{"color":"secondary"},on:{"click":function (e) {
        e.stopPropagation();
        _vm.$emit('addRequirementsToStep', _vm.step, 'required_by');
      }}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-clock-out")]),_vm._v(" \"Benötigt von\" übernehmen ")],1),_c('v-btn',{attrs:{"color":"secondary"},on:{"click":function (e) {
        e.stopPropagation();
        _vm.$emit('addRequirementsToStep', _vm.step);
      }}},[_vm._v(" Beide übernehmen ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }